module.exports = __webpack_public_path__ + "frontend/img/illustration.7dc12155.svg";